export default __webpack_public_path__ + "static/media/EN-US.35155ddb.svg";